import { Box } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';

const AppMobileBottomNavContainer = ({ isOpen, setIsOpen, children, isClose, sx }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        height: { xs: isOpen ? '100%' : 0, md: 0 },
        width: '100%',
        transition: 'height 0.5s',
        background: 'rgba(66, 133, 244, 0.07)',
        mixBlendMode: 'normal',
        backdropFilter: 'blur(7.5px)',
        zIndex: 300,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-center',
        overflowY: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          height: { xs: isOpen ? 'auto' : 0, mmd: 0 },
          maxHeight: { xs: '750px', md: 0 },
          width: '100%',
          transition: 'height 0.5s',
          boxShadow: '-5px -1px 10px -2px rgba(0,0,0,.3)',
          zIndex: '99999',
          overflow: 'auto',
          background: '#fff',
          padding: '20px',
          borderRadius: '16px 16px 0 0',
          ...sx
        }}
      >
        <Box
          sx={{
            position: 'sticky',
            top: '0px',
            right: '20px',
            height: '40px',
            display: isClose ? 'flex' : 'none',
            justifyContent: 'flex-end'
          }}
        >
          <CloseIcon
            sx={{
              width: '32px',
              height: '32px',
              color: 'primary.black',
              cursor: 'pointer'
            }}
            onClick={() => setIsOpen(false)}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}

export default AppMobileBottomNavContainer